var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery2Low(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 149,
    viewBox: "0 0 142 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5407 69.0898C11.6083 59.6363 17.3606 41.75 32.3889 29.1398C47.4172 16.5295 66.0306 13.9705 73.9631 23.424L125.219 84.5088C133.152 93.9623 127.399 111.849 112.371 124.459C97.3427 137.069 78.7294 139.628 70.7969 130.175L19.5407 69.0898Z",
    fill: "#245F9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5789 68.4672C8.17284 58.4493 14.1825 39.5675 30.0017 26.2935C45.821 13.0196 65.4595 10.38 73.8655 20.398L122.213 78.0162C130.619 88.0341 124.609 106.916 108.79 120.19C92.9708 133.464 73.3323 136.103 64.9263 126.085L16.5789 68.4672Z",
    fill: "#D5DBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0756 108.519C40.5675 97.188 48.6438 80.8094 64.4386 67.5559C80.2334 54.3025 97.7657 49.1931 107.274 60.5244L119.923 75.5989C131.894 88.4137 124.632 107.215 108.838 120.469C93.0428 133.722 71.6571 137.143 62.7246 123.594L50.0756 108.519Z",
    fill: "#E92A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M106.922 59.7924C114.692 69.0527 108.167 87.3203 92.3482 100.594C76.5289 113.868 58.0018 117.832 50.2315 108.572C42.4612 99.3116 48.9862 81.044 64.8054 67.7701C80.6247 54.4961 99.1519 50.5322 106.922 59.7924Z",
    fill: "#FF4545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5338 68.0509L76.41 74.0285C74.5473 75.5914 71.7162 74.9467 70.7382 72.7368L64.7515 59.2109C63.7028 56.8415 60.1362 57.7191 60.2808 60.3113L62.42 98.6739C62.5894 101.713 66.1548 103.238 68.4963 101.273L75.6201 95.2956C77.4828 93.7326 80.3139 94.3774 81.2919 96.5872L87.2785 110.113C88.3273 112.483 91.8938 111.605 91.7493 109.013L89.61 70.65C89.4405 67.6114 85.8751 66.0863 83.5338 68.0509Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5334 68.0531L77.9629 72.7273C79.9441 81.9694 76.8498 92.0035 69.0657 98.5351C67.5788 99.7828 65.9949 100.838 64.3454 101.707C65.5981 102.378 67.2265 102.341 68.4959 101.275L75.6197 95.2978C77.4824 93.7348 80.3135 94.3796 81.2915 96.5894L87.2782 110.115C88.3269 112.485 91.8935 111.607 91.7489 109.015L89.6098 70.652C89.4401 67.6136 85.8747 66.0885 83.5334 68.0531Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.0359,
    cy: 39.4408,
    rx: 33.6521,
    ry: 17.1662,
    transform: "rotate(-40 41.0359 39.4408)",
    fill: "#245F9B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7768,
    cy: 31.9828,
    rx: 18.6956,
    ry: 9.28583,
    transform: "rotate(-40 34.7768 31.9828)",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery2Low);
export default __webpack_public_path__ + "static/media/battery-2-low.c90165414952765479a47c87a681fc40.svg";
export { ForwardRef as ReactComponent };